<div class="npdc-search">
  <div class="npdc-search__input">
    <div class="npdc-search__input__prefix">
      <mat-icon>search</mat-icon>
    </div>
    <input
      type="search"
      [placeholder]="'Search in ' + prefix() || 'all directories'"
      [value]="q()"
      (keydown.enter)="
        filter(0, pageSize(), $any($event).target.value, prefix(), from(), until(), order())
      "
    />
  </div>
  <button mat-icon-button matTooltip="Advanced search" (click)="openSearch()">
    <mat-icon>tune</mat-icon>
  </button>
</div>

<!-- breadcrumbs -->
<p style="display: flex; justify-content: space-between">
  <span>
    <ng-container
      [ngTemplateOutlet]="breadcrumb"
      [ngTemplateOutletContext]="{ path: prefix(), active: true }"
    >
    </ng-container>
  </span>

  @if (count() || paths().length) {
    <a
      style="flex-shrink: 0"
      mat-stroked-button
      download
      [href]="archiveUrl()"
      matTooltip="Download selection as ZIP"
      [appAuthorize]="authService.user() !== null"
    >
      <mat-icon>download</mat-icon>
      @if (archiveInformation.hasValue()) {
        @let info = archiveInformation.value();
        <span> {{ info.byteSize | humanReadableSize }} - {{ info.count }} files </span>
      } @else {
        <span>Download</span>
      }
    </a>
  }
</p>

<!-- applied filter list -->
@if (!prefix() || from() || until() || order()) {
  <mat-chip-set>
    @if (order(); as value) {
      <mat-chip highlighted title="{{ order() }}">
        {{ value.replace(/\:.*$/, '') | titlecase }}
        <mat-icon matChipTrailingIcon>
          @if (value.endsWith('desc')) {
            arrow_downward
          } @else {
            arrow_upward
          }
        </mat-icon>
        <mat-icon
          matChipRemove
          (click)="filter(0, pageSize(), q(), '/', from(), until(), undefined)"
          >cancel</mat-icon
        >
      </mat-chip>
    }
    @if (!prefix()) {
      <mat-chip highlighted>
        All directories
        <mat-icon matChipRemove (click)="filter(0, pageSize(), q(), '/', from(), until(), order())"
          >cancel</mat-icon
        >
      </mat-chip>
    }
    @if (from(); as value) {
      <mat-chip highlighted>
        From: {{ value | date }}
        <mat-icon
          matChipRemove
          (click)="filter(0, pageSize(), q(), prefix(), null, until(), order())"
          >cancel</mat-icon
        >
      </mat-chip>
    }
    @if (until(); as value) {
      <mat-chip highlighted>
        Until: {{ value | date }}
        <mat-icon
          matChipRemove
          (click)="filter(0, pageSize(), q(), prefix(), from(), null, order())"
          >cancel</mat-icon
        >
      </mat-chip>
    }
  </mat-chip-set>
}

<!-- directory list -->
<mat-action-list>
  @for (path of paths(); track path) {
    @if (getDirectory(path); as directory) {
      <button mat-list-item (click)="filter(0, pageSize(), q(), path, from(), until(), order())">
        <mat-icon matListItemIcon>folder</mat-icon>
        <span matListItemTitle
          ><strong>{{ directory.title }}</strong></span
        >
      </button>
    }
  }
</mat-action-list>

@if (paths().length) {
  <mat-divider></mat-divider>
}

<!-- file list -->
<app-list [resource]="attachments" [disableClear]="true">
  @if (!attachments.error()) {
    <mat-action-list>
      @for (attachment of attachments.value()?.items; track attachment.id) {
        <button mat-list-item (click)="open(attachment)">
          <mat-icon matListItemIcon>
            @if (!isReleased(attachment)) {
              lock
            } @else {
              description
            }
          </mat-icon>

          <span matListItemTitle>
            <ng-container
              [ngTemplateOutlet]="attachmentTitle"
              [ngTemplateOutletContext]="{ attachment: attachment }"
            >
            </ng-container>
          </span>

          <span matListItemMeta>{{ attachment.byteSize | humanReadableSize }}</span>
        </button>
      }
    </mat-action-list>

    <mat-paginator
      showFirstLastButtons
      (page)="filter($event.pageIndex, $event.pageSize, q(), prefix(), from(), until(), order())"
      [length]="count()"
      [pageIndex]="page()"
      [pageSize]="pageSize()"
      [pageSizeOptions]="[10, 20, 50, 100]"
    >
    </mat-paginator>
  }
</app-list>

<ng-template #breadcrumb let-path="path" let-active="active">
  @if (getDirectory(path); as directory) {
    @if (directory.prev) {
      <ng-container
        [ngTemplateOutlet]="breadcrumb"
        [ngTemplateOutletContext]="{ path: directory.prev }"
      >
      </ng-container>
      <span>></span>
    }

    <button
      class="npdc-breadcrumb"
      [class.npdc-breadcrumb__active]="active"
      [disabled]="active"
      mat-button
      (click)="filter(0, pageSize(), q(), directory.path, from(), until(), order())"
    >
      <h2>{{ directory.title === '/' ? 'Files' : directory.title }}</h2>
    </button>
  }
</ng-template>

<ng-template #attachmentTitle let-attachment="attachment">
  @if (canDownload(attachment)) {
    <a
      target="_blank"
      href="{{ hostUrl }}/dataset/{{ attachment.datasetId }}/attachment/{{ attachment.id }}/_blob"
      appStopPropagation
      [appAuthorize]="requiresAuthorization(attachment)"
    >
      <ng-container
        [ngTemplateOutlet]="title"
        [ngTemplateOutletContext]="{ attachment: attachment }"
      >
      </ng-container>
    </a>
  } @else {
    <span>
      <ng-container
        [ngTemplateOutlet]="title"
        [ngTemplateOutletContext]="{ attachment: attachment }"
      >
      </ng-container>
    </span>
  }
</ng-template>

<ng-template #title let-attachment="attachment"
  >{{ prefix() === attachment.prefix ? '' : attachment.prefix
  }}{{ attachment.title || attachment.filename }}</ng-template
>
